import AgencyImportCommand from "./entryCommands/AgencyImportCommand.js";
import CreateDirectoryCommand from "./entryCommands/CreateDirectoryCommand.js";
import DeleteCommand from "./entryCommands/DeleteCommand.js";
import DownloadCommand from "./entryCommands/DownloadCommand.js";
import EditEntryPermissionsCommand from "./entryCommands/EditEntryPermissionsCommand.js";
import ExportCommand from "./entryCommands/ExportCommand.js";
import ImportCommand from "./entryCommands/ImportCommand.js";
import MarkAsPreliminaryCommand from "./entryCommands/MarkAsPreliminaryCommand.js";
import MoveCommand from "./entryCommands/MoveCommand.js";
import NotifyUsersCommand from "./entryCommands/NotifyUsersCommand.js";
import RenameCommand from "./entryCommands/RenameCommand.js";
import UploadCommand from "./entryCommands/UploadCommand.js";

const commands = [
	DeleteCommand,
	RenameCommand,
	DownloadCommand,
	UploadCommand,
	CreateDirectoryCommand,
	MoveCommand,
	EditEntryPermissionsCommand,
	MarkAsPreliminaryCommand,
	ExportCommand,
	ImportCommand,
	AgencyImportCommand,
	NotifyUsersCommand,
];

/**
 * Return a list of `AbstractEntryCommand` instances that are
 * applicable to a given `context`. An "applicable" command is a
 * command the user is allowed to use in a given context. The function
 * creates each applicable command by passing the `documentService` to
 * the constructor.
 *
 * @param {documentService} documentService - The service taking care
 * of the execution of commands and communication with the server.
 * @param {object} context - The data to pass to each command class to
 * decide if the class is applicable.
 * @param {User} context.user - The user currently using the
 * application and whose permissions will be checked to decide if a
 * command is applicable.
 * @param {Company} context.company - The company owning the document
 * archive.
 */
export function applicableCommands(documentService, { user, company }) {
	return commands
		.filter((CommandClass) => CommandClass.isApplicable({ user, company }))
		.map((CommandClass) => new CommandClass({ documentService }));
}
